import React, { useState, useEffect } from "react";
import Srcollbar from "react-perfect-scrollbar";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { BsFileEarmarkArrowUp, BsFileEarmarkArrowDown } from "react-icons/bs";
import { downloadFileByURL } from "app/_helpers/reactHelper";
import toastr from "toastr";
import {
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Card,
  ListGroup,
  ListGroupItem,
  Modal,
} from "react-bootstrap";
import { FiPlusCircle, FiEdit3, FiEye } from "react-icons/fi";
import { FaRegTrashAlt, FaCheck } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";

import {
  createTraining,
  getAllTrainings,
  updateTraining,
  createByExcel,
  deleteTraining,
} from "app/_services/ehs/ehsServices";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { FcApprove } from "react-icons/fc";

const initialForm = {
  id: "",
  name: "",
  status: 0,
};

const OneColumnTable = ({ title, name, type }) => {
  const [tableData, setTableData] = useState([]);
  const [showManageModal, setShowManageModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showTableModal, setShowTableModal] = useState(false);
  const [form, setForm] = useState({ ...initialForm, type });
  const [errorForm, setErrorForm] = useState({ ...initialForm, type });

  const [filterData, setFilterData] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    setFilterData(tableData);
  }, [tableData]);

  const handleChange = (e) => {
    e.preventDefault();
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    if (!searchInput) {
      setFilterData(tableData);
      return;
    }
    let tData = [];
    tData = tableData.filter((data) => {
      return data?.name?.toLowerCase().includes(searchInput?.toLowerCase());
    });
    console.log("check++++++", tData);
    setFilterData(tData);
  }, [searchInput, tableData]);

  useEffect(() => {
    if (showViewModal || showManageModal) return;

    setForm({ ...initialForm, type });
    setErrorForm({ ...initialForm, type });
  }, [showViewModal, showManageModal, type]);

  useEffect(() => {
    getAllTrainings(`filter[type]=${type}`).then((response) => {
      if (!response?.data) return;
      setTableData(response.data);
    });
  }, [type, setTableData]);

  const approveData = CommmonService.debounce(async function () {
    let updated = false;

    for (const data of tableData) {
      if (data.status === 1) continue;

      await CommmonService.approveReject({
        id: data.id,
        status: 1,
        tableName: "ehsTraining",
      });

      data.status = 1;
      updated = true;
    }

    toastr.success("Approved All Entries.");

    if (updated) setTableData([...tableData]);
  }, 1500);

  const onChange = ({ target: { name, value } }) => {
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const editTraining = (id, name) => {
    setForm((prevForm) => ({ ...prevForm, id, name }));
    setShowTableModal(false);
    setShowManageModal(true);
  };

  const viewTraining = (id, name) => {
    setForm((prevForm) => ({ ...prevForm, id, name }));
    setShowTableModal(false);
    setShowViewModal(true);
  };

  const deleteTrainingById = (id) => {
    confirmAlert({
      title: `Delete ${name}.`,
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const response = await deleteTraining(id);

            if (!response?.status) return toastr.error(response?.message);

            toastr.success(response.message || "Success.");

            tableData.splice(
              tableData.findIndex((data) => data.id === id),
              1
            );

            setTableData([...tableData]);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const onSubmit = async () => {
    if (
      tableData.find(
        (data) =>
          data.id !== form.id &&
          data.name.trim().toLowerCase() === form.name.trim().toLowerCase()
      )
    )
      return toastr.warning(`Same ${name} already exists!`);

    if (!form.name.trim())
      return setErrorForm((prev) => ({ ...prev, name: "Name is required!" }));
    if (form.name.length > 30)
      return setErrorForm((prev) => ({ ...prev, name: "Max 30 Characters allowed!" }));

    setErrorForm({ ...initialForm, type });
    let response;

    form.type = type;

    if (!form.id) response = await createTraining(form);
    else response = await updateTraining(form.id, form);

    if (!response?.status) return toastr.error(response?.message);

    toastr.success(response.message || "Success.");

    if (!form.id) {
      form.id = response.data.id;
      tableData.push(form);
    } else tableData[tableData.findIndex((data) => data.id === form.id)].name = form.name;

    setTableData(tableData);
    setShowManageModal(false);
    if (form.id) setShowTableModal(true);
  };
  const ExportExcel = (e) => {
    e.preventDefault();
    downloadFileByURL(
      URL_CONFIG.DEV_URL + "global-configuration/ehs-module/download-by-excel",
      `Designation-${new Date().toISOString()}.xls`
    );
  };
  const onFileChange = (e) => {
    const { files } = e.target;
    let formData = new FormData();
    formData.append("file", files[0]);
    const response = createByExcel(formData);
    const timerId = setTimeout(() => {
      getAllTrainings(`filter[type]=${type}`).then((response) => {
        if (!response?.data) return;
        setTableData(response.data);
      });
    }, 1500);
  };

  return (
    <Card className="training-card compliance-name-table">
      <Card.Body>
        <Card.Title>
          <span
            className="pointer"
            onClick={() => {
              setShowTableModal(true);
            }}
          >
            {title}
          </span>
        </Card.Title>
        <div className="btn-toolbar" style={{ alignItems: "center" }}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Add {name}</Tooltip>}
          >
            <span
              className="icons btn-icon font-20 text-cyanBlue pointer"
              onClick={() => {
                setShowManageModal(true);
              }}
            >
              <FiPlusCircle />
            </span>
          </OverlayTrigger>
          <CustomTooltip tooltip="Import Excel">
            <div className="uploadFileBtn btn-icon ml-2">
              <label htmlFor="upload-single-file">
                <BsFileEarmarkArrowUp size="24" />
              </label>
              <input className="uploadFile" type="file" onChange={onFileChange}></input>
            </div>
          </CustomTooltip>
          <CustomTooltip tooltip="Export Excel">
            <div className="uploadFileBtn btn-icon ml-2">
              <label htmlFor="upload-single-file">
                <BsFileEarmarkArrowDown size="24" onClick={ExportExcel} />
              </label>
            </div>
          </CustomTooltip>

          {tableData.filter((data) => data.status !== 1).length ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Approve All Entries</Tooltip>}
            >
              <span onClick={approveData} className="btn-icon text-success pointer">
                <FaCheck size={18} />
              </span>
            </OverlayTrigger>
          ) : (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">All Entries Approved</Tooltip>}
            >
              <span className="icons btn-icon font-20 text-success">
                <FcApprove size={28} />
              </span>
            </OverlayTrigger>
          )}
        </div>
      </Card.Body>
      <Srcollbar className="trainingManagementFixedHeight">
        <ListGroup className="list-group-flush">
          {tableData.map((data, index) => (
            <span
              className={`${data.status === 0 ? "text-warning" : ""}`}
              onClick={() => {
                viewTraining(data.id, data.name);
              }}
              key={index}
            >
              <ListGroupItem key={index}>{data.name}</ListGroupItem>
            </span>
          ))}
        </ListGroup>
      </Srcollbar>
      <Modal
        show={showManageModal}
        onHide={() => {
          setShowManageModal(false);
        }}
      >
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">
                {form.id ? "Edit" : "Add"} {name}
              </h3>
            </div>
            <Row className="mb-3">
              <Col md="12">
                <div className="form-group">
                  <label>Training {name}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={form.name}
                    onChange={onChange}
                  />
                  <span className="text-danger small">{errorForm.name}</span>
                </div>
              </Col>
            </Row>
            <div className="mt-2 text-center">
              <Button
                onClick={() => {
                  setShowManageModal(false);
                }}
                className="btn btn-secondary mr-2"
              >
                Close
              </Button>
              <Button
                onClick={onSubmit}
                type="submit"
                variant="primary"
                className="m-1 text-capitalize"
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        show={showViewModal}
        onHide={() => {
          setShowViewModal(false);
        }}
      >
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">View {name}</h3>
            </div>
            <Row className="mb-3">
              <Col md="12">
                <div>
                  <label className="font-weight-bolder">Training {name}:</label>
                  <span className="mx-2">{form.name}</span>
                </div>
              </Col>
            </Row>
            {form.id && (
              <div>
                <LogHistory subModulename="ehsTraining" refrenceId={form.id} />
              </div>
            )}
            <div className="mt-2 text-center">
              <Button
                onClick={() => {
                  setShowViewModal(false);
                }}
                className="btn btn-secondary mr-2"
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal show={showTableModal} onHide={() => setShowTableModal(false)}>
        <div className="card" style={{ overflow: "hidden" }}>
          <Modal.Header closeButton>
            <Modal.Title>Trainingg {title}</Modal.Title>
          </Modal.Header>
          <div style={{ width: "200px", marginLeft: "20px", marginTop: "10px" }}>
            <input
              class="form-control"
              type="text"
              placeholder="Search here"
              onChange={handleChange}
              value={searchInput}
            />
          </div>
          <div className="card-body">
            <Srcollbar className="modalTableFixedheight">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filterData.map((data, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <span className={`${data.status === 0 ? "text-warning" : ""}`}>
                          {data.name}
                        </span>
                      </td>
                      <td>
                        <div className="actionIconsGroup">
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
                          >
                            <span
                              className="pointer text-cyanBlue icons"
                              onClick={() => {
                                viewTraining(data.id, data.name);
                              }}
                            >
                              <FiEye />
                            </span>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                          >
                            <span
                              className="pointer icons text-cyanBlue"
                              onClick={() => {
                                editTraining(data.id, data.name);
                              }}
                            >
                              <FiEdit3 />
                            </span>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                          >
                            <span
                              className="pointer icons text-danger"
                              onClick={() => {
                                deleteTrainingById(data.id);
                              }}
                            >
                              <FaRegTrashAlt />
                            </span>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Srcollbar>
          </div>
        </div>
      </Modal>
    </Card>
  );
};

export default OneColumnTable;
